import { SignInPage } from '@backstage/core-components';
import type { IdentityProviders } from '@backstage/core-components';
import { gitlabAuthApiRef } from '@backstage/core-plugin-api';
import type { SignInPageProps } from '@backstage/core-plugin-api';
import { configApiRef, useApi } from '@backstage/frontend-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';

/**
 * Studio sign-in page (Auth B).
 *
 * Always offers "Sign in with GitLab" (the official Backstage GitLab auth API, registered
 * by default in the new frontend system). The guest fallback is offered ONLY when
 * `auth.environment` is `development`, matching the backend, which loads the guest provider
 * only in that environment. In staging/production the guest button is absent AND the backend
 * has no guest provider, so it cannot be used even if forged.
 */
const studioSignInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => (props: SignInPageProps) => {
      const config = useApi(configApiRef);
      const environment =
        config.getOptionalString('auth.environment') ?? 'development';

      const providers: IdentityProviders = [
        {
          id: 'gitlab-auth-provider',
          title: 'GitLab',
          message: 'Sign in with your GitLab account',
          apiRef: gitlabAuthApiRef,
        },
      ];
      // Development convenience only — never in staging/production.
      if (environment === 'development') {
        providers.unshift('guest');
      }

      return <SignInPage {...props} providers={providers} />;
    },
  },
});

export { studioSignInPage };
